import { gql } from '@apollo/client';
import { createModelSegment } from 'client/data/luckdragon/segment';
import { EdmundsGraphQLFederation } from 'client/data/graphql/graphql-client';
import { withMetrics } from 'client/data/api/api-metrics';

const DEFAULT = 'default';

export function buildVehicleDataPath({ make, model, year }) {
  return !!make && !!model && `makes["${make}"].models["${model}"].years["${year || DEFAULT}"].vehicleData`;
}

export const VehicleEditorialModel = createModelSegment('vehicleEditorial', [
  /**
   * @see buildVehicleDataPath
   */
  {
    path: 'makes["{make}"].models["{model}"].years["{year}"].vehicleData',
    async resolve({ make, model, year }, context) {
      return withMetrics(EdmundsGraphQLFederation, context)
        .query(
          gql`
            query ($make: String!, $model: String!, $year: Int!, $hasYear: Boolean!) {
              makes(makeSlug: $make) {
                id
                models(modelSlug: $model) {
                  modelLinkCodes
                  publicationStates
                }
              }
              modelYears(makeSlug: $make, modelSlug: $model, year: $year) @include(if: $hasYear) {
                id
              }
            }
          `,
          {
            make,
            model,
            year: parseInt(year, 10) || 0,
            hasYear: year !== DEFAULT,
          }
        )
        .then(response => ({
          makeId: response?.makes?.[0]?.id,
          modelLinkCode: response?.makes?.[0]?.models?.[0]?.modelLinkCodes?.[0],
          publicationStates: response?.makes?.[0]?.models?.[0]?.publicationStates,
          modelYearId: response?.modelYears?.[0]?.id,
        }));
    },
  },
]);
